<template>
<div class="chat-box">
    <div class="chat-header">
        <div class="chat-header-left" v-if="roomList[currentRoomId]">
            {{roomList[currentRoomId].memberName}}
            {{roomList[currentRoomId].isFacialVerify ? '(已认证)' : '(未认证)'}}
        </div>
        <div class="chat-header-left chat-header-case" v-else>
            <div class="case-color1">
                群聊({{dataList.memberCount}}人)
            </div>
            <div class="case-color2">
                <div class="case-Num-margin">案号：{{dataList.bizRoomName}}</div>
                <div class="case-Name-margin">案由：{{dataList.causeName}}</div>
            </div>
        </div>
    </div>
    <div class="chat-message" ref="chatMessage" id="chatMessage">
        <template v-if="chatMsgs.length > 0">
            <div class="more top" v-if="msgIndex == allMsgPages&&msgIndex>1">已拉到最顶端</div>
            <div class="more" :data-num1="msgIndex" :data-num2="allMsgPages" @click="getscollChatMsgList" v-else-if="isLoadingMsg === false&&allMsgPages>1">查看更多消息</div>
            <div class="more" v-else-if="isLoadingMsg">加载中</div>
        </template>
        <div class="more" v-else-if="!isLoadingMsg&&chatMsgs.length === 0">暂无消息</div>
        <div class="more" v-else-if="isLoadingMsg">加载中</div>
        <template v-for="(item,index) in chatMsgs">
            <div class="message broadcast" v-if="item.isBroadcast" :key="index">
                <div class="profile">
                    <div class="avatar">
                        <img src="@/assets/casespace/chat-broadcast-avatar.png" alt="avatar" />
                    </div>
                </div>
                <div class="text" style="max-width:800px;">{{item.content}}</div>
            </div>
            <div :class="item.memberId == userId ? 'message me' : 'message'" :key="'message' + index" v-else>
                <div class="profile">
                    <div class="avatar">
                        <template v-if="isClosed">
                            <img :src="item.senderHeadUrl" v-if="item.senderHeadUrl" alt="senderHeadUrl" />
                            <img src="@/assets/casespace/avatar_default.png" v-else alt="avatar_default" />
                        </template>
                        <template v-else>
                            <img :src="memberHeaderUrl[item.memberId].headPortraitUrl" v-if="memberHeaderUrl[item.memberId] && memberHeaderUrl[item.memberId].headPortraitUrl" alt="" />
                            <img src="@/assets/casespace/avatar_default.png" alt="" v-else />
                        </template>
                    </div>
                    <p class="info">{{item.memberType}} {{item.memberName}}<span class="time">{{dateFormat(item.createTime, 'yyyy-MM-dd hh:mm:ss')}}</span></p>
                </div>
                <div class="text document" v-if="item.messageType === 'DOCUMENT_INFO' &&  Boolean(~item.categoryBig.indexOf('DOCUMENT'))">
                    <p class="document-info">{{item.memberType}}向所有当事人发送了《{{JSON.parse(item.content).fileName}}》，请详细查看文书内容</p>
                    <div class="document-detail">
                        <img class="icon" src="../../../assets/casespace/document-blue.png" alt="">
                        <span>《{{JSON.parse(item.content).fileName}}》</span>
                        <div class="crossExamin" v-if="!mediatorState" @click="handleSign">签署</div>
                    </div>
                </div>
                <div class="content evidenceMsg" v-else-if="item.messageResource === 'HANDLER_INPUT'&&item.messageType==='EVIDENCE'" style="width:250px">
                    <div class="text file evidenceMsg-margin">
                        <div class="evidenceMsg-flex" v-for="(url, index) in item.content" :key="index">
                            <a :href="url.filePath" target="_blank" class="file-preview" v-if="url.categoryBig === 'IMG'">
                                <img class="type-icon" :src="baseUrl + '/gzzc/docBook/previewImg/' + url.fileId" alt="">
                            </a>
                            <a @click="filePreviewClick(url.filePath)" target="_blank" class="file-preview" v-if="url.categoryBig === 'OTHER'">
                                <img class="type-icon" src="../../../assets/casespace/file-img.png" alt="">
                            </a>
                            <div class="file-detail">
                                <p v-if="url.categoryBig === 'IMG'" class="file-name">证据图片信息</p>
                                <!--  -->
                                <template v-else-if="url.categoryBig === 'OTHER' && !url.filePath">
                                    <p class="file-name">证据名称:{{url.edvName}}</p>
                                    <p class="file-name">证据附件:暂无</p>
                                </template>
                                <p v-else class="file-name">证据视频/文件信息</p>
                                <i class="el-icon-download" @click="downloadSendFile(url)" v-if="url.filePath" alt=""></i>
                            </div>
                            <div class="crossExamin" v-if="!mediatorState" @click="handleCrossExamin">质证</div>
                        </div>
                    </div>
                </div>
                <div class="content evidenceMsg" v-else-if="item.messageType === 'QUESTION_SHEET'" style="width:250px">
                    <div class="text file evidenceMsg-margin">
                        <div class="evidenceMsg-flex">
                            <div class="qa-content">
                                <p class="qa">仲裁员在问题单中添加了问题,请当事人尽快回答。</p>
                            </div>
                            <div class="qalink" v-if="!mediatorState" @click="handleAnswer">去回答</div>
                        </div>
                    </div>
                </div>
                <div class="text music" v-else-if="item.messageType === 'FILE' && item.categoryBig === 'VOICE'">
                    <audio :src="item.filePath" controls="controls" width="240px;" style="border:1px solid #fff;border-radius:5px;" controlsList="nodownload">
                    </audio>
                </div>

                <div class="text" v-else>{{item.content}}</div>
                <!--问题单-->
            </div>
        </template>
    </div>
    <div class="send-wrap" ref="sendWrap" v-if="!isClosed1">
        <div class="operation">
            <img class="icon voice operation-item" title="语音" :src="sendAudiobtn ? require('@/assets/casespace/voice.png'): require('@/assets/casespace/voice-light.png')" @click="onSendAudioMessageClick()" alt="" />
            <template v-if="canUpload && spaceType==0"><img class="icon file operation-item" title="提供证据" src="@/assets/casespace/file.png" @click="handleSendFile" alt="" /></template>
            <template v-if="mediatorState && !privateState && spaceType==0"><img class="icon document operation-item" @click="handleSendQA" title="发送问题单" src="@/assets/casespace/document.png" alt="" /></template>
        </div>
        <div class="chat-message_speaking">
            <textarea v-model="inputMessage" @keyup.enter.exact="sendChatMessage" class="input-textarea" placeholder="在此输入消息，按回车键发送"></textarea>
            <div class="chat-message_btnSend">
                <button @click="sendChatMessage"><img src="../../../assets/images/send.png" alt=""> 发送</button>
            </div>
        </div>
    </div>
    <uploadEvidence ref="uploadEvidence" :ws="wsLink" :currentRoomId="currentRoomId" :showEvidenceDialog="showEvidenceDialog" @handleClose="handleClose"></uploadEvidence>
    <create-question v-if="showCreateQuestion" @createQuestionEvent="createQuestionSuccessHandler" @closeEvent="closeCreateQuestionEvent"></create-question>
</div>
</template>

<script>
import AlertEmit from './alertEmit'
import CreateQuestion from '@/views/caseSpace/questionList/createQuestion'
import IFlyIatSession from '@/utils/iat.js'
import {
    dateformat,
    getStore
} from '@/utils/utils.js'
import filedownload from '@/utils/filedown.js'
import filedownExtra from '@/utils/filedownExtra.js'
import {
    roomMsg,
    oneToOneMsg
} from '@/api/casespace.js'
import uploadEvidence from '@/components/uploadEvidence.vue'
import {
    UserRole,
    GetMediationRoomUserInfoList
} from '@/common/js/roleMixin.js'
import {
    userButton
} from "@/common/js/buttonMixin.js"
import config from '@/config/config.js'
export default {
    props: ['wsLink', 'currentRoomId', 'isClosed', 'dataList', 'roomId', 'memberHeaderUrl', 'privateState'],
    mixins: [UserRole, GetMediationRoomUserInfoList, userButton],
    components: {
        uploadEvidence,
        CreateQuestion
    },
    data() {
        return {
            spaceType: 0, // 默认0  0异步庭审   1异步调解   2在线送达
            canUpload: true,
            showEvidenceDialog: false,
            inputMessage: '',
            sendAudiobtn: true,
            chatMsgs: [],
            msgIndex: null, // 当前的聊天记录页数
            allMsgPages: null, //总的聊天记录页数
            isLoadingMsg: false, //是否正在加载聊天记录
            userId: null, // 当前登录的用户
            userList: {}, //缓存用户聊天头像，认证信息
            roomList: {}, //缓存房间信息,
            isOnGroupMsg: true, //是否在群聊窗口
            currentCategory: null, // 当前过滤条件
            mediator: '',
            attachId: '', //文书下载id
            mediatorState: false,
            showCreateQuestion: false,
            baseUrl: "https://" + config.hostName, //资源地址
            isClosed1: localStorage.getItem('CloseState') == 'true' ? true : false
        }
    },
    created() {
        // console.log(this.$store.getters.getWSLink)
        if (this.$route.query.spaceType) {
            this.spaceType = Number(this.$route.query.spaceType)
        }
        AlertEmit.$on('sendBookWebSocket', args => {
            this.compontCallback(args, 'sendDoc')
        })
    },
    mounted() {
        let loginInfouser = JSON.parse(getStore('loginInfo'));
        this.userId = loginInfouser.memberId
        this.mediator = loginInfouser.memberName
        let context = this.$refs.chatMessage
        let sendWrapObj = this.$refs.sendWrap
        let sendWrapObjHeight = sendWrapObj ? sendWrapObj.offsetHeight : 0
        if (loginInfouser.hasOwnProperty('personType') && loginInfouser.personType == 'STAFF') {
            this.mediatorState = true
        }
        context.addEventListener('scroll', this.handleScroll)
        context.style.height = this.isClosed ? (document.body.clientHeight - 382 + 'px') : (document.body.clientHeight - 460 + 'px')

        let isWorker = loginInfouser.personType === 'STAFF' ? true : false
        if (!isWorker) {
            this.canUpload = false
            let data = getStore('canUpload')
            if (data != undefined) {
                this.canUpload = data==1 ? true : false
            }
        }

        document.getElementById('chatContentList').style.height = document.body.clientHeight - 332 + 'px'
        this.IFlyIatSessionInit()
        this.initGroupMsg();
        this.getBaseInfo();
    },
    watch: {
        currentRoomId(newCurrentRoomId, oldCurrentRoomId) {
            console.log(newCurrentRoomId, '-------------', this.roomId)
            this.currentCategory = null
            if (newCurrentRoomId === this.roomId) {
                this.isOnGroupMsg = true
                this.initGroupMsg();
            } else {
                this.isOnGroupMsg = false
                this.initPrivateMsg();
            }
            this.$nextTick(() => {
                let context = this.$refs.chatMessage
                context.scrollTop = context.scrollHeight;
            })
        },
        dataList: {
            handler(curVal, oldVal) {
                this.getBaseInfo();
            },
            deep: true
        }
    },
    methods: {
        // 文件预览
        filePreviewClick(filePath) {
            if (filePath) {
                window.open(filePath)
            } else {
                this.$message.warning('暂无附件')
            }
            console.log(filePath, 'hedahai')
        },
        // 创建问题成功的回调
        createQuestionSuccessHandler() {
            //获取子组件发送文书回调参数
            let data = {
                roomId: this.currentRoomId,
                messageType: 'QUESTION_SHEET',
                categoryBig: '', //非必填
                messageResource: 'HANDLER_INPUT',
                content: JSON.stringify({
                    questionText: '', //小程序签名使用
                })
            }
            let msgdata = {};
            msgdata.event = "SEND_MESSAGE";
            msgdata.data = data;
            console.log("发送", msgdata)
            this.wsLink.send(JSON.stringify(msgdata))
        },
        // 关闭新增问题对话框事件回调
        closeCreateQuestionEvent() {
            this.showCreateQuestion = false;
        },
        handleDownloadDoc(content) {
            const id = this.attachId ? this.attachId : content.attachId,
                fileName = content.fileName
            filedownload(`/gzzc/file/clerkRecordDownload`, {
                id,
            }, fileName)
        },
        handleSendFile() {
            console.log(this.$refs)
            this.showEvidenceDialog = true
        },
        //发送问题单
        handleSendQA(type) {
            this.showCreateQuestion = true
        },
        //进入视频庭审
        enterVideoMeetingLink(item) {
            let loginInfo = JSON.parse(getStore('loginInfo'))
            let personType = loginInfo.personType
            if (personType === 'STAFF') {
                this.$router.push({
                    path: `/meeting/mediator?roomid=${item.roomId}&caseid=${item.caseId}&meetingid=${item.meetingId}`
                })
            } else {
                this.$router.push({
                    path: `/meeting/member?roomid=${item.roomId}&caseid=${item.caseId}&meetingid=${item.meetingId}`
                })
            }
        },
        getBaseInfo() {
            let userList = {},
                roomList = {}
            this.dataList.members.forEach(member => {
                userList[member.memberId] = {
                    memberName: member.memberName,
                    isFacialVerify: member.isFacialVerify,
                    headUrl: member.headUrl
                }
                roomList[member.roomId] = {
                    memberId: member.memberId,
                    memberName: member.memberName,
                    isFacialVerify: member.isFacialVerify,
                    headUrl: member.headUrl
                }
            })
            this.userList = userList
            this.roomList = roomList
        },
        // 群聊 - 刚进聊天室通过http获取聊天消息
        initGroupMsg() {
            this.isLoadingMsg = true
            this.chatMsgs = []
            console.log('ri', this.dataList.roomId)
            roomMsg({
                pageIndex: 1,
                pageSize: 20,
                roomId: this.dataList.roomId,
                categoryBig: this.currentCategory,
            }).then(res => {
                if (res.data.code === 1000) {
                    let data = res.data.data;
                    if (data) {
                        this.allMsgPages = data.totalPages;
                        this.msgIndex = 1;
                        this.showChatMsgList(data.list.reverse())
                    }
                } else {
                    this.$message.error(res.data.message);
                }
            }).finally(res => {
                this.isLoadingMsg = false
            })
        },
        // 单聊 - 刚进聊天室通过http获取聊天消息
        initPrivateMsg() {
            this.isLoadingMsg = true
            this.chatMsgs = []
            console.log('currentRoomId:', this.currentRoomId)
            oneToOneMsg({
                pageIndex: 1,
                pageSize: 20,
                roomId: this.currentRoomId,
                categoryBig: this.currentCategory,
            }).then(res => {
                console.log('privateChatMsg:', res)
                if (res.data.code === 1000) {
                    let data = res.data.data;
                    if (data) {
                        this.allMsgPages = data.totalPages;
                        this.msgIndex = 1;
                        this.showChatMsgList(data.list.reverse())
                    }
                } else {
                    this.$message.error(res.data.message);
                }
            }).finally(res => {
                this.isLoadingMsg = false
            })
        },
        //下载聊天框发送的文件
        downloadSendFile(item) {
            const id = item.id,
                fileId = item.fileId,
                fileName = item.fileName,
                caseId = this.$route.params.id
            filedownload(`/pisces/file/fileDownload`, {
                fileId,
                caseId
            }, fileName)
        },
        // 下载非业务的文件
        downloadOtherFile(item) {
            const id = item.id,
                fileId = item.fileId,
                fileName = item.fileName,
                caseId = this.$route.params.id
            filedownExtra(`/pisces/file/download/`, fileId, fileName)
        },
        //聊天室滚动时候触发的事件
        handleScroll() {
            let context = this.$refs.chatMessage
            if (context.scrollTop === 0) {
                // this.getscollJURORMsgList()
            }
        },
        //加载更多消息
        getscollChatMsgList() {
            console.log('this.msgIndex', this.msgIndex, this.allMsgPages)
            if (this.msgIndex === this.allMsgPages) return;
            this.isLoadingMsg = true
            let pageIndex = this.msgIndex + 1
            if (this.isClosed) {
                if (this.isOnGroupMsg) {
                    roomMsg({
                        pageIndex,
                        "pageSize": 20,
                        roomId: this.currentRoomId,
                        categoryBig: this.currentCategory
                    }).then(res => {
                        if (res.data.code === 1000) {
                            let data = res.data.data;
                            this.msgIndex = pageIndex;
                            this.allMsgPages = data.totalPages;
                            this.showChatMsgList(data.list.reverse())
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }).finally(res => {
                        this.isLoadingMsg = false
                    })
                } else {
                    oneToOneMsg({
                        pageIndex,
                        "pageSize": 20,
                        roomId: this.currentRoomId,
                        categoryBig: this.currentCategory,
                    }).then(res => {
                        if (res.data.code === 1000) {
                            let data = res.data.data;
                            this.msgIndex = pageIndex;
                            this.allMsgPages = data.totalPages;
                            this.showChatMsgList(data.list.reverse())
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }).finally(res => {
                        this.isLoadingMsg = false
                    })
                }
            } else {
                let data = {
                    roomId: this.currentRoomId,
                    pageIndex,
                    pageSize: 20
                };
                let msgdata = {};
                msgdata.event = "LIST_MESSAGE";
                msgdata.data = data;
                this.msgIndex = pageIndex;
                this.wsLink.send(JSON.stringify(msgdata))
            }
        },
        // 语音转文字
        sendMessage(msg) {
            let data = {
                    content: msg,
                    roomId: this.currentRoomId,
                    messageResource: 'VOICE_DISCERN'
                },
                msgdata = {};
            msgdata.event = "SEND_TEXT";
            msgdata.data = data;
            this.wsLink.send(JSON.stringify(msgdata))
        },
        dateFormat(data, type) {
            if (data) {
                return dateformat(new Date(data), type)
            }
        },
        // 语音转文字识别后发出
        onSendAudioMessageClick() {
            if (this.sendAudiobtn) {
                this.sendAudiobtn = false;
                console.log('发送语音------')
                IFlyIatSession.IFlyLatPlay()
            } else {
                this.sendAudiobtn = true;
                console.log('关闭语音------')
                IFlyIatSession.IFlyLatKill()
            }
        },
        // 初始化语音转写实例
        IFlyIatSessionInit() {
            let _this = this
            let iflysession = {
                sendMessage: function (result) {
                    console.log('案件空间发送语音消息--------')
                    _this.sendMessage(result)
                },
                onError: function (code, msg) {
                    _this.sendAudiobtn = true
                    //_this.$message.error(msg)
                }
            }
            IFlyIatSession.init(iflysession, false)
        },
        enterRoom(res) {
            if (res) {
                if (res.event === "BROADCAST_MESSAGE") { //自己新发的消息
                    this.showChatMsgList([res.data], true, true)
                } else if (res.event === "LIST_MESSAGE") { //消息列表
                    this.allMsgPages = res.data.totalPages;
                    this.showChatMsgList(res.data.list.reverse())
                }
            }
        },
        // 按enter键或者发送键发送消息
        sendChatMessage() {
            if (this.inputMessage) {
                let msg = this.inputMessage.toString();
                msg = msg.replace((/\n/g, "<br>"))
                if (msg.length > 2000) {
                    this.$message({
                        message: '发送内容最多2000字符',
                        type: 'warning'
                    });
                    return
                }
                this.inputMessage = "";
                let data = {
                    content: msg,
                    roomId: this.currentRoomId,
                    messageResource: 'HANDLER_INPUT'
                };
                let msgdata = {};
                msgdata.event = "SEND_TEXT";
                msgdata.data = data;
                console.log('messageinfo:', msgdata)
                this.wsLink.send(JSON.stringify(msgdata))
            } else {
                this.$message({
                    message: '聊天消息不能为空',
                    type: 'warning'
                });
            }
        },
        // 拼接聊天消息记录
        getMsgList(item, tempList) {
            let obj = {}
            obj.content = item.messageContent
            obj.messageType = item.messageType // TEXT / FILE
            obj.messageResource = item.messageResource
            obj.fileName = item.fileName ? item.fileName : ""
            obj.fileType = item.fileName ? item.fileName.split('.').reverse()[0] : ""
            obj.fileId = item.fileId
            obj.id = item.id
            obj.createTime = item.createTime
            obj.roomId = item.roomId
            obj.categoryBig = item.categoryBig
            obj.senderHeadUrl = item.senderHeadUrl
            if (item.messageType === 'FILE') {
                let content = item.messageContent
                content = JSON.parse(content)
                obj.filePath = content.filePath
            }
            if (item.messageType === 'EVIDENCE') {
                let content = item.messageContent
                content = JSON.parse(content)
                obj.content = content
            }
            if (item.messageType === 'REVIEW_EVIDENCE') {
                let content = item.messageContent
                content = JSON.parse(content)
                if (content.questionType == 1) {
                    content.content = content.content.map(item => {
                        return item.path
                    })
                }
                obj.content = content
            }
            if (item.sender) {
                obj.memberType = this.meetingTypeEnum[item.sender.memberType]
                obj.memberId = item.sender.memberId
                obj.memberName = item.sender.memberName
                obj.isBroadcast = false
            } else {
                obj.isBroadcast = true
            }
            tempList.push(obj)
            return tempList
        },
        showChatMsgList(msgList, isNewMessage = false, isBroadcast = false) {
            let tempList = []
            // 需要对BROADCAST_MESSAGE的消息进行过滤（会收到该账户其它案件发来的消息）。
            // LIST_MESSAGE跟http接口不需要过滤
            console.log('msgList===', msgList)
            msgList.forEach((item) => {
                if (isBroadcast) {
                    if (item.roomId !== this.currentRoomId) return;
                    tempList = this.getMsgList(item, tempList)
                } else {
                    tempList = this.getMsgList(item, tempList)
                }
            })

            let context = this.$refs.chatMessage
            if (isNewMessage) {
                this.chatMsgs.push(...tempList)
                this.$nextTick(() => {
                    if (!context) return;
                    context.scrollTop = context.scrollHeight;
                })
            } else if (this.msgIndex === 1) {
                this.chatMsgs = tempList
                this.$nextTick(() => {
                    if (!context) return;
                    context.scrollTop = context.scrollHeight;
                })
            } else {
                let prevScrollHeight = context.scrollHeight;
                this.chatMsgs.unshift(...tempList)
                this.$nextTick(() => {
                    if (!context) return;
                    context.scrollTop = context.scrollHeight - prevScrollHeight;
                })
            }
            this.isLoadingMsg = false
            console.log('chatMsgs:', this.chatMsgs)
        },
        handleClose() {
            console.log('22222222222')
            this.showEvidenceDialog = false
        },
        handleCrossExamin() {
            this.$router.replace({
                path: `/caseSpace?roomid=${this.$route.query.roomid}&activeName=third&activeIndex=2&caseid=${this.$route.query.caseid}&meetingid=${this.$route.query.meetingid}&token=${this.$route.query.token}&memberId=${this.$route.query.memberId}&memberName=${this.$route.query.memberName}&memberType=${this.$route.query.memberType}&isClosed=${this.isClosed}`
            })
            location.reload()
        },
        handleSign() {
            this.$router.replace({
                path: `/caseSpace?roomid=${this.$route.query.roomid}&activeName=fourth&activeIndex=4&caseid=${this.$route.query.caseid}&meetingid=${this.$route.query.meetingid}&token=${this.$route.query.token}&memberId=${this.$route.query.memberId}&memberName=${this.$route.query.memberName}&memberType=${this.$route.query.memberType}&isClosed=${this.isClosed}`
            })
            location.reload()
        },
        handleAnswer() {
            this.$router.replace({
                path: `/caseSpace?roomid=${this.$route.query.roomid}&activeName=second&activeIndex=1&caseid=${this.$route.query.caseid}&meetingid=${this.$route.query.meetingid}&token=${this.$route.query.token}&memberId=${this.$route.query.memberId}&memberName=${this.$route.query.memberName}&memberType=${this.$route.query.memberType}&isClosed=${this.isClosed}`
            })
            location.reload()
        },
        compontCallback(obj, sendDoc) {
            console.log(obj, '----', sendDoc)
            //获取子组件发送文书回调参数
            //'sendDoc'判断文书列表上传时候所有往群聊发送
            let data = {
                roomId: sendDoc === 'sendDoc' ? this.dataList.roomId : this.currentRoomId,
                filePath: obj.filePath,
                categoryBig: 'DOCUMENT'
            }
            this.attachId = obj.attachId
            data = Object.assign(data, obj)
            let msgdata = {};
            msgdata.event = "SEND_BOOK";
            msgdata.data = data;
            console.log('发送文书:', msgdata)
            this.wsLink.send(JSON.stringify(msgdata))
            let data2 = {
                roomId: sendDoc === 'sendDoc' ? this.dataList.roomId : this.currentRoomId,
                messageType: 'DOCUMENT_INFO',
                categoryBig: 'DOCUMENT', //非必填
                messageResource: 'SYSTEM_AUTO_INPUT',
                content: JSON.stringify({
                    fileName: obj.fileName,
                    attachId: obj.attachId,
                    docId: obj.docId, //小程序签名使用
                    docsendtype: obj.docsendtype,
                    filePath: obj.filePath,
                    receiver: obj.receivers,
                    source: obj.source
                })
            }
            let msgdata2 = {};
            msgdata2.event = "SEND_MESSAGE";
            msgdata2.data = data2;
            console.log("发送", msgdata2)
            this.wsLink.send(JSON.stringify(msgdata2))
        }
    }
}
</script>

<style lang="scss">
.chat-box {
    .chat-header-case {
        display: flex;
        width: 100%;
        justify-content: space-between;

        .case-color1 {
            display: flex;
            align-items: center;
            width: 152px;
        }

        .case-color2 {
            display: flex;
            color: #1e6dcb;
            font-size: 14px;

            .case-Num-margin {
                display: flex;
                align-items: center;
                min-width: 240px;
                margin-left: 20px;
                justify-content: center;
            }

            .case-Name-margin {
                margin-left: 18px;
            }
        }
    }

    .more {
        position: absolute;
        top: 0;
        left: 48%;
        font-size: 14px;
        color: #1e6dcb;
        text-align: center;
        padding: 20px 0;
        cursor: pointer;

        &.top {
            cursor: default;
        }
    }

    .chat-message {
        position: relative;
        padding: 50px 15px 0;
        overflow: auto;
    }

    .message {
        padding: 0 0 60px 0;
        position: relative;
        clear: both;
        min-width: 300px;

        .profile {
            position: absolute;
            font-size: 12px;
            color: #666666;
            bottom: 35px;

            .avatar {
                width: 30px;
                height: 30px;
                // background-color: #0090f0;
                border-radius: 50%;
                display: inline-block;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .info {
                padding-top: 8px;
            }

            .time {
                padding-left: 10px;
            }
        }

        .text {
            white-space: pre-wrap;
            position: relative;
            font-size: 14px;
            color: #666666;
            padding: 10px 16px;
            background-color: #f2f5f7;
            max-width: 400px;
            display: inline-block;
            border-radius: 8px;
            margin-left: 38px;
            word-break: break-word;

            .el-icon-download {
                cursor: pointer;
            }

            &:before {
                position: absolute;
                display: block;
                width: 0;
                height: 0;
                content: " ";
                border-width: 6px;
                border-color: transparent;
                border-style: solid;
                margin-left: -6px;
                border-top-width: 0;
                border-bottom-color: #f2f5f7;
                left: 0;
                bottom: 0;
            }

            &.word {
                width: 212px;
                padding: 0;

                .type {
                    background-color: #0090f0;
                    text-align: center;
                    height: 86px;
                    border-radius: 8px 8px 0 0;
                }

                .type-icon {
                    display: inline-block;
                    margin: 20px 0 18px;
                }

                .file-detail {
                    background-color: #f2f5f7;
                    padding: 0 20px;
                    border-radius: 0 0 8px 8px;
                }

                .file-name {
                    font-size: 16px;
                    color: #666666;
                    padding: 10px 0px 5px;
                }

                .file-size {
                    font-size: 14px;
                    color: #b8b8b8;
                    padding-bottom: 3px;
                }
            }

            &.document {
                padding: 10px 0;

                .document-info {
                    padding: 0 16px 10px;
                    border-bottom: 1px solid #d8d8d8;
                }

                .document-detail {
                    padding: 10px 16px 0;
                    clear: both;

                    .icon {
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 10px;
                    }
                }

                .link {
                    float: right;
                    padding-top: 4px;
                    color: #1e6dcb;
                }
            }

            &.file {
                width: 226px;
                clear: both;

                .file-preview {
                    width: 60px;
                    height: 60px;
                    float: left;

                    img,
                    video {
                        width: 100%;
                        height: 100%;
                    }
                }

                .file-detail {
                    margin-left: 76px;

                    .file-video {
                        color: #1e6dcb;
                    }
                }

                .file-name {
                    white-space: nowrap;
                    width: 164px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    padding: 0 0 10px 0;
                }
            }

            &.video-meeting {
                white-space: normal;

                .link {
                    color: #1e6dcb;
                }
            }
        }

        .music {
            .music-flex {
                display: flex;
                align-items: center;

                a {
                    .el-button {
                        margin-top: 0 !important;
                    }
                }
            }

            .file-detail {
                .file-name {
                    display: inline;
                }

                .el-icon-download {
                    margin-left: 20px;
                }
            }
        }

        &.me {
            float: right;

            .profile {
                right: 0;
                text-align: right;

                .time {
                    padding-left: 0;
                    padding-right: 10px;
                    float: left;
                }
            }

            .text {
                margin-right: 38px;
                margin-left: 0px;
                float: right;

                &:before {
                    left: 100%;
                }
            }
        }

        &.broadcast {
            padding: 0 0 30px 0;

            .profile {
                top: 0;

                .info {
                    display: none;
                }
            }
        }

        &:last-child {
            padding: 0 0 40px 0;

            .profile {
                bottom: 10px;
            }
        }

        .evidenceMsg-margin {
            margin-right: 0 !important;
            position: relative;
        }

        .crossExamin {
            text-align: right;
            color: #1e6dcb;
            cursor: pointer;
        }

        .evidenceMsg-flex {
            height: 70px;
            padding-top: 10px;

            .file-preview {
                float: left;
            }
        }
    }

    .send-wrap {
        position: relative;
        border-top: 1px solid #d8d8d8;

        .operation {
            padding-left: 30px;
            line-height: 50px;

            .operation-item {
                margin-right: 38px;
            }

            .operation-item-line {
                margin-top: 10px;
            }

            .icon {
                display: inline-block;
                cursor: pointer;
            }
        }
    }

    .chat-message_speaking {
        padding: 0 10px 10px;

        .input-textarea {
            font-size: 16px;
            width: 100%;
            height: 80px;
            display: inline-block;
            padding: 5px 10px;
            border: none;
            color: #494949;
            resize: none;
            outline: 0;
            -webkit-appearance: none;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            -webkit-transition: all .3s cubic-bezier(.645, .045, .355, 1);
            -webkit-transition: all .3s cubic-bezier(0.65, 0.05, 0.36, 1);
            transition: all .3s cubic-bezier(0.65, 0.05, 0.36, 1);
        }
    }

    .chat-message_btnSend {
        display: inline-block;
        vertical-align: top;

        button {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            bottom: 20px;
            right: 27px;
            color: #fff;
            border: none;
            outline: 0;
            width: 110px;
            height: 40px;
            background-color: #1e6dcb;
            box-shadow: 2px 8px 16px 0px rgba(59, 119, 217, 0.2);
            border-radius: 4px;
            cursor: pointer;
            line-height: 40px;
            font-size: 16px;

            .icon {
                display: inline-block;
                vertical-align: sub;
                margin-right: 5px;
            }

            img {
                margin-right: 10px;
            }
        }
    }

    .qa-content {
        width: 100%;
        height: 45px;

        .qa {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }

    .qalink {
        width: 100%;
        height: 30px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;
        color: #0090f0;
    }
}
</style>
